import { jsxs, jsx } from 'react/jsx-runtime';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-badge.css';
import { EGDSBadgeSize, EGDSBadgeLoyaltyThemes } from '../types/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
import { validatePropType } from '../../utils/validate-prop-types/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSBadgeLoyalty = props => {
  const {
    text,
    size,
    theme,
    children,
    a11yText,
    className
  } = props;
  const sharedCssClassName = 'uitk-badge-base';
  const baseCssClassName = 'uitk-badge';
  const loyaltyCssClassName = `${baseCssClassName}-loyalty`;
  const loyaltyBadgeClassNames = getClassNameList(sharedCssClassName, `${sharedCssClassName}-${validatePropType(size, EGDSBadgeSize) ? size : EGDSBadgeSize.LARGE}`, {
    [`${sharedCssClassName}-has-text`]: text
  }, `${loyaltyCssClassName}-${validatePropType(theme, EGDSBadgeLoyaltyThemes) ? theme : EGDSBadgeLoyaltyThemes.LOW}`, className);
  return jsxs("span", {
    className: loyaltyBadgeClassNames,
    children: [children, text && jsx("span", {
      className: getClassNameList(`${sharedCssClassName}-text`),
      "aria-hidden": !!a11yText,
      children: text
    }), a11yText && jsx("span", {
      className: getClassNameList('is-visually-hidden'),
      children: a11yText
    })]
  });
};
EGDSBadgeLoyalty.displayName = 'EGDSBadgeLoyalty';
export { EGDSBadgeLoyalty };